export { BuscaChipsModule } from './busca-chips.module';
export { BuscaChips } from './busca-chips.component';
export { ChipOption, ChipSelected } from './busca-chips.component';
